module.exports = __webpack_public_path__ + "static/pictureWall-3a9a7a512d29755b3a89ec289332eadf.png";